/**
 * Bins widgets into rows of at most `max` shares.
 *
 * Widgets carry an intrinsic width (3 for a number, 12 for a wide table), but
 * those rarely add up to a full row — three billboards leave a quarter of the
 * row empty. Grouping them explicitly lets each row divide its whole width
 * between its members, so every row reaches the right edge.
 */
export function packRows(items, max = 12) {
  const rows = [];
  let current = [];
  let used = 0;

  for (const item of items) {
    const width = Math.min(Math.max(1, item.span?.w ?? max), max);
    if (used + width > max && current.length) {
      rows.push(current);
      current = [];
      used = 0;
    }
    current.push(item);
    used += width;
  }
  if (current.length) rows.push(current);
  return rows;
}
